export default __webpack_public_path__ + "static/ball-a5ebab2fff97b0e1f4734cf51afb5402.webp";